export enum Limpidite {
    Inconnu = 0,
    Limpide = 1,
    LegerementTrouble = 2,
    Trouble = 3,
}
